export default class AddClassToRow {
  constructor() {
    this.factRows = document.querySelectorAll('.vc_row .animated-facts-numbers');
    this.iconTextTwoColRows = document.querySelectorAll('.vc_row .vc_col-sm-6 .icon-with-text');
    this.iconTextThreeColRows = document.querySelectorAll('.vc_row .vc_col-sm-4 .icon-with-text');
  }

  init() {
    this.FactsComponentRow();
    this.IconTextTwoColRow();
    this.IconTextThreeColRow();
  }

  FactsComponentRow() {
    this.factRows.forEach((factRow) => {
      factRow.closest('.vc_row').classList.add('no-gutters-fact');
    });
  }

  IconTextTwoColRow() {
    const className = 'small-gutter-icon-with-text';

    this.iconTextTwoColRows.forEach((iconTextTwoColRow) => {
      iconTextTwoColRow.closest('.vc_row').classList.add(className);
    });

    AddClassToRow.checkRowsAndAddClassToLastRowWithSmallOrNoGutter(className);
  }

  IconTextThreeColRow() {
    const className = 'no-gutter-icon-with-text';

    this.iconTextThreeColRows.forEach((iconTextThreeColRow) => {
      iconTextThreeColRow.closest('.vc_row').classList.add(className);
    });

    AddClassToRow.checkRowsAndAddClassToLastRowWithSmallOrNoGutter(className);
  }

  static checkRowsAndAddClassToLastRowWithSmallOrNoGutter(className) {
    const rows = document.querySelectorAll(`.${className}`);

    rows.forEach((row) => {
      if (row.nextElementSibling && !row.nextElementSibling.classList.contains(className)) {
        row.classList.add('last-row-with-small-or-no-gutter');
      }
    });
  }
}
